import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseConversation, RConversation} from './conversationModel';
import {DataGroupModel} from './dataGroupModel';

/*
 * Runtime type.
 */

const RRecentConversationsDirty = t.intersection([
  t.type({
    hasMore: t.boolean,
  }),
  t.partial({
    conversations: t.readonlyArray(RConversation),
    conversationIds: t.array(t.number),
    isOnlyPrivate: t.boolean,
  }),
]);

/*
 * Type.
 */

export interface RecentConversationsModel extends t.TypeOf<typeof RRecentConversationsDirty> {}
export const RRecentConversations = t.clean<RecentConversationsModel>(RRecentConversationsDirty as any);

/*
 * IO methods.
 */

export function parseRecentConversations(src: any): RecentConversationsModel {
  return {
    conversations: src.conversations?.map(parseConversation) || undefined,
    conversationIds: src.conversation_ids || undefined,
    hasMore: src.has_more || false,
    isOnlyPrivate: src.is_only_private || false,
  };
}

export function parseRecentConversationsFromDataGroup(dataGroup: DataGroupModel): RecentConversationsModel {
  const cardConversations: RecentConversationsModel = {
    conversations: dataGroup.conversations || [],
    hasMore: dataGroup.hasMore || false,
  };
  return cardConversations;
}

/*
 * API type.
 */

export const ApiRecentConversations = makeApiType(
  'recentConversations',
  RRecentConversations,
  parseRecentConversations,
);
